import { useSelector } from "react-redux";
export const useAppSelector = (selector) => useSelector(selector);
